/**
 * Action type to signal the closing of the material list.
 */
export const MATERIAL_LIST_CLOSE = 'MATERIAL_LIST_CLOSE';
/**
 * Action type to signal the opening of the material list.
 */
export const MATERIAL_LIST_OPEN = 'MATERIAL_LIST_OPEN';
